import { useParams } from 'wouter';
import { ClientProgramNames } from '../../../constants';
import { AuthedPage } from '../../../app';
import { Logo } from '@platform/components';

export const ApplicationClosedPage = () => {
  const { clientName } = useParams<{ clientName: string }>();
  let programName = 'MovingWorlds';
  switch (clientName) {
    case 'sap':
      programName = ClientProgramNames.SAP;
      break;
    case 'f5':
      programName = ClientProgramNames.F5;
      break;
    case 'lumen':
      programName = ClientProgramNames.LUMEN;
      break;
    case 'ey':
      programName = ClientProgramNames.EY;
      break;
    case 'reckitt':
      programName = ClientProgramNames.RECKITT;
      break;
    default:
      programName = ClientProgramNames.INDIVIDUAL;
      return;
  }

  return (
    <AuthedPage>
      <div className='bg-gray-50'>
        <div className='w-full p-4'>
          <Logo type='mw-text' variant='blue' />
        </div>
        <div className='flex flex-col overflow-x-clip overflow-y-auto h-[100vh]  p-20'>
          <div className='max-w-[800px] mx-auto'>
            <ApplicationsClosedContent programName={programName} />
          </div>
        </div>
      </div>
    </AuthedPage>
  );
};

export const ApplicationsClosedContent = ({ programName }: { programName: string }) => {
  return (
    <div className='w-full p-10 bg-white rounded-xl border border-gray-100 text-center'>
      <h3 className='text-lg font-medium'>This {programName} application period is closed</h3>
      <p className='text-sm text-gray-500 mt-2'>
        Please check back later for updates or&nbsp;
        <SupportLink />
        &nbsp;for more information.
      </p>
    </div>
  );
};

const SupportLink = () => {
  return (
    <a className='blue-link' href='mailto:support@movingworlds.org'>
      contact support
    </a>
  );
};
